import AcquirerStoreTable from "../../pages/acquirerStore/AcquirerStoreTable";
import AcquirerTable from "../../pages/acquirer/AcquirerTable";
import AddressTable from "../../pages/address/AddressTable";
import ApiConfigTable from "../../pages/apiConfig/ApiConfigTable";
import BankDetailTable from "../../pages/bankDetail/BankDetailTable";
import BankJobTable from "../../pages/bankJob/BankJobTable";
import BusinessSettlementSummaryTable from "../../pages/businessSettlementSummary/BusinessSettlementSummaryTable";
import BusinessTable from "../../pages/business/BusinessTable";
import ChargeRateTable from "../../pages/chargeRate/ChargeRateTable";
import Charts from "../../pages/charts";
import Dashboard from "../../pages/dashboard";
import DenormalizedSettlementTransactionTable from "../../pages/denormalizedSettlementTransaction/DenormalizedSettlementTransactionTable";
import DeviceTokenTable from "../../pages/deviceToken/DeviceTokenTable";
import DisplayMessageTable from "../../pages/displayMessage/DisplayMessageTable";
import EmailJobTable from "../../pages/emailJob/EmailJobTable";
import Header from "../Header";
import Icon from "@mdi/react";
import Icons from "../../pages/icons";
import ItemDetailTable from "../../pages/itemDetail/ItemDetailTable";
import Maps from "../../pages/maps";
import NegativeBalanceJobTable from "../../pages/negativeBalanceJob/NegativeBalanceJobTable";
import BankCode from "../../pages/bankCode/BankCodeTable";

import TransactionMonitorDataTable from "../../pages/transactionMonitorData/TransactionMonitorDataTable";
import FixNewOrder from "../../pages/fixNewOrder";

import Notifications from "../../pages/notifications";
import OneTimePasswordTable from "../../pages/oneTimePassword/OneTimePasswordTable";
import React from "react";
import RefundTable from "../../pages/refund/RefundTable";
import RegionTable from "../../pages/region/RegionTable";
import RoleAccessTable from "../../pages/roleAccess/RoleAccessTable";
import SettlementConfigTable from "../../pages/settlementConfig/SettlementConfigTable";
import SettlementRecordTable from "../../pages/settlementRecord/SettlementRecordTable";
import SettlementTimeRecordTable from "../../pages/settlementTimeRecord/SettlementTimeRecordTable";
import Sidebar from "../Sidebar";
import StoreAcquirerSettlementSummaryTable from "../../pages/storeAcquirerSettlementSummary/StoreAcquirerSettlementSummaryTable";
import StoreSettlementSummaryTable from "../../pages/storeSettlementSummary/StoreSettlementSummaryTable";
import StoreTable from "../../pages/store/StoreTable";
import Tables from "../../pages/tables";
import TerminalTable from "../../pages/terminal/TerminalTable";
import TransactionTable from "../../pages/transaction/TransactionTable";
import Typography from "../../pages/typography";
import UserBusinessAccessTable from "../../pages/userBusinessAccess/UserBusinessAccessTable";
import UserRoleAccessTable from "../../pages/userRoleAccess/UserRoleAccessTable";
import UserStoreAccessTable from "../../pages/userStoreAccess/UserStoreAccessTable";
import UserTable from "../../pages/user/UserTable";
import AcquireStoreSettlementDetailTable from "../../pages/acquireStoreSettlementDetail/AcquireStoreSettlementDetailTable";
import classnames from "classnames";
import useStyles from "./styles";
import { useLayoutState } from "../../context/LayoutContext";
import { Box, IconButton, Link } from "@material-ui/core";

import StoreDcsConfigurationTable from "../../pages/storeDcsConfiguration/StoreDcsConfiguration";

import { Route, Switch, Redirect, withRouter } from "react-router-dom";

// icons
import {
  mdiFacebook as FacebookIcon,
  mdiTwitter as TwitterIcon,
  mdiGithub as GithubIcon,
} from "@mdi/js";

// styles

// components

// pages
// context

function Layout(props) {
  const classes = useStyles();

  // global
  const layoutState = useLayoutState();

  return (
    <div className={classes.root}>
      <>
        <Header history={props.history} />
        <Sidebar />
        <div
          className={classnames(classes.content, {
            [classes.contentShift]: layoutState.isSidebarOpened,
          })}
        >
          <div className={classes.fakeToolbar} />
          <Switch>
            <Route exact path="/bak" render={() => <Redirect to="/bak/dashboard" />} />
            <Route path="/bak/dashboard"  component={Dashboard} />
            <Route path="/bak/typography" component={Typography} />
            <Route path="/bak/tables" component={Tables} />
            <Route path="/bak/notifications" component={Notifications} />
            <Route
              exact
              path="/bak/ui"
              render={() => <Redirect to="/bak/ui/icons" />}
            />

            <Route path="/bak/ui/maps" component={Maps} />
            <Route path="/bak/ui/icons" component={Icons} />
            <Route path="/bak/ui/charts" component={Charts} />

            <Route
              exact
              path="/bak/user"
              render={() => <Redirect to="/bak/user/table" />}
            />
            <Route path="/bak/user/table" component={UserTable} />

            <Route
              exact
              path="/bak/business"
              render={() => <Redirect to="/bak/business/table" />}
            />

            <Route path="/bak/business/table" component={BusinessTable} />

            <Route
              exact
              path="/bak/region"
              render={() => <Redirect to="/bak/region/table" />}
            />

            <Route path="/bak/region/table" component={RegionTable} />

            <Route
              exact
              path="/bak/address"
              render={() => <Redirect to="/bak/address/table" />}
            />

            <Route path="/bak/address/table" component={AddressTable} />

            <Route
              exact
              path="/bak/bankDetail"
              render={() => <Redirect to="/bak/bankDetail/table" />}
            />

            <Route path="/bak/bankDetail/table" component={BankDetailTable} />

            <Route
              exact
              path="/bak/userBusinessAccess"
              render={() => <Redirect to="/bak/userBusinessAccess/table" />}
            />

            <Route
              path="/bak/userBusinessAccess/table"
              component={UserBusinessAccessTable}
            />

            <Route
              exact
              path="/bak/userStoreAccess"
              render={() => <Redirect to="/bak/userStoreAccess/table" />}
            />

            <Route
              path="/bak/userStoreAccess/table"
              component={UserStoreAccessTable}
            />

            <Route
              exact
              path="/bak/roleAccess"
              render={() => <Redirect to="/bak/roleAccess/table" />}
            />

            <Route path="/bak/roleAccess/table" component={RoleAccessTable} />

            <Route
              exact
              path="/bak/userRoleAccess"
              render={() => <Redirect to="/bak/userRoleAccess/table" />}
            />

            <Route
              path="/bak/userRoleAccess/table"
              component={UserRoleAccessTable}
            />
            <Route
              exact
              path="/bak/apiConfig"
              render={() => <Redirect to="/bak/apiConfig/table" />}
            />

            <Route path="/bak/apiConfig/table" component={ApiConfigTable} />

            <Route
              exact
              path="/bak/acquirer"
              render={() => <Redirect to="/bak/acquirer/table" />}
            />

            <Route path="/bak/acquirer/table" component={AcquirerTable} />

            <Route
              exact
              path="/bak/settlementConfig"
              render={() => <Redirect to="/bak/settlementConfig/table" />}
            />

            <Route
              path="/bak/settlementConfig/table"
              component={SettlementConfigTable}
            />

            <Route
              exact
              path="/bak/acquirerStore"
              render={() => <Redirect to="/bak/acquirerStore/table" />}
            />

            <Route
              path="/bak/acquirerStore/table"
              component={AcquirerStoreTable}
            />

            <Route
              exact
              path="/bak/store"
              render={() => <Redirect to="/bak/store/table" />}
            />

            <Route path="/bak/store/table" component={StoreTable} />

            <Route
              exact
              path="/bak/chargeRate"
              render={() => <Redirect to="/bak/chargeRate/table" />}
            />

            <Route path="/bak/chargeRate/table" component={ChargeRateTable} />

            <Route
              exact
              path="/bak/transaction"
              render={() => <Redirect to="/bak/transaction/table" />}
            />

            <Route path="/bak/transaction/table" component={TransactionTable} />

            <Route
              exact
              path="/bak/terminal"
              render={() => <Redirect to="/bak/terminal/table" />}
            />

            <Route path="/bak/terminal/table" component={TerminalTable} />

            <Route
              exact
              path="/bak/deviceToken"
              render={() => <Redirect to="/bak/deviceToken/table" />}
            />

            <Route path="/bak/deviceToken/table" component={DeviceTokenTable} />

            <Route
              exact
              path="/bak/oneTimePassword"
              render={() => <Redirect to="/bak/oneTimePassword/table" />}
            />

            <Route
              path="/bak/oneTimePassword/table"
              component={OneTimePasswordTable}
            />

            <Route
              exact
              path="/bak/transactionMonitorData"
              render={() => <Redirect to="/bak/transactionMonitorData/table" />}
            />

            <Route path="/bak/transactionMonitorData/table" component={TransactionMonitorDataTable} />

            <Route path="/bak/fixNewOrder" component={FixNewOrder} />

            <Route
              exact
              path="/bak/refund"
              render={() => <Redirect to="/bak/refund/table" />}
            />

            <Route path="/bak/refund/table" component={RefundTable} />

            <Route
              exact
              path="/bak/displayMessage"
              render={() => <Redirect to="/bak/displayMessage/table" />}
            />

            <Route
              path="/bak/displayMessage/table"
              component={DisplayMessageTable}
            />

            <Route
              exact
              path="/bak/settlementRecord"
              render={() => <Redirect to="/bak/settlementRecord/table" />}
            />

            <Route
              path="/bak/settlementRecord/table"
              component={SettlementRecordTable}
            />

            <Route
              exact
              path="/bak/settlementTimeRecord"
              render={() => <Redirect to="/bak/settlementTimeRecord/table" />}
            />

            <Route
              path="/bak/settlementTimeRecord/table"
              component={SettlementTimeRecordTable}
            />

            <Route
              exact
              path="/bak/denormalizedSettlementTransaction"
              render={() => (
                <Redirect to="/bak/denormalizedSettlementTransaction/table" />
              )}
            />

            <Route
              path="/bak/denormalizedSettlementTransaction/table"
              component={DenormalizedSettlementTransactionTable}
            />

            <Route
              exact
              path="/bak/businessSettlementSummary"
              render={() => (
                <Redirect to="/bak/businessSettlementSummary/table" />
              )}
            />

            <Route
              path="/bak/businessSettlementSummary/table"
              component={BusinessSettlementSummaryTable}
            />

            <Route
              exact
              path="/bak/storeSettlementSummary"
              render={() => <Redirect to="/bak/storeSettlementSummary/table" />}
            />

            <Route
              path="/bak/storeSettlementSummary/table"
              component={StoreSettlementSummaryTable}
            />

            <Route
              exact
              path="/bak/storeAcquirerSettlementSummary"
              render={() => (
                <Redirect to="/bak/storeAcquirerSettlementSummary/table" />
              )}
            />

            <Route
              path="/bak/storeAcquirerSettlementSummary/table"
              component={StoreAcquirerSettlementSummaryTable}
            />

            <Route
              exact
              path="/bak/emailJob"
              render={() => <Redirect to="/bak/emailJob/table" />}
            />

            <Route path="/bak/emailJob/table" component={EmailJobTable} />

            <Route
              exact
              path="/bak/bankJob"
              render={() => <Redirect to="/bak/bankJob/table" />}
            />

            <Route path="/bak/bankJob/table" component={BankJobTable} />

            <Route
              exact
              path="/bak/negativeBalanceJob"
              render={() => <Redirect to="/bak/negativeBalanceJob/table" />}
            />

            <Route
              path="/bak/negativeBalanceJob/table"
              component={NegativeBalanceJobTable}
            />

            <Route
              exact
              path="/bak/bankCode"
              render={() => <Redirect to="/bak/bankCode/table" />}
            />

            <Route path="/bak/bankCode/table" component={BankCode} />

            <Route
              exact
              path="/bak/acquireStoreSettlementDetail"
              render={() => <Redirect to="/bak/acquireStoreSettlementDetail/table" />}
            />

            <Route path="/bak/acquireStoreSettlementDetail/table" component={AcquireStoreSettlementDetailTable} />

            <Route
              exact
              path="/bak/StoreDcsConfiguration"
              render={() => <Redirect to="/bak/StoreDcsConfiguration/table" />}
            />

            <Route path="/bak/StoreDcsConfiguration/table" component={StoreDcsConfigurationTable} />

 
          </Switch>
          <Box
            mt={5}
            width={"100%"}
            display={"flex"}
            alignItems={"center"}
            justifyContent="space-between"
          >
            {/* <div>
              <Link
                color={"primary"}
                href={"https://flatlogic.com/"}
                target={"_blank"}
                className={classes.link}
              >
                Flatlogic
              </Link>
              <Link
                color={"primary"}
                href={"https://flatlogic.com/about"}
                target={"_blank"}
                className={classes.link}
              >
                About Us
              </Link>
              <Link
                color={"primary"}
                href={"https://flatlogic.com/blog"}
                target={"_blank"}
                className={classes.link}
              >
                Blog
              </Link>
            </div> */}
            {/* <div>
              <Link
                href={"https://www.facebook.com/flatlogic"}
                target={"_blank"}
              >
                <IconButton aria-label="facebook">
                  <Icon path={FacebookIcon} size={1} color="#6E6E6E99" />
                </IconButton>
              </Link>
              <Link href={"https://twitter.com/flatlogic"} target={"_blank"}>
                <IconButton aria-label="twitter">
                  <Icon path={TwitterIcon} size={1} color="#6E6E6E99" />
                </IconButton>
              </Link>
              <Link href={"https://github.com/flatlogic"} target={"_blank"}>
                <IconButton aria-label="github" style={{ marginRight: -12 }}>
                  <Icon path={GithubIcon} size={1} color="#6E6E6E99" />
                </IconButton>
              </Link>
            </div> */}
          </Box>
        </div>
      </>
    </div>
  );
}

export default withRouter(Layout);
